export default __webpack_public_path__ + "static/media/R1.b7b95436.JPG";